export const setMe = ({ peerId, loginEnabled, email, name, socketId }) =>
	({
		type    : 'SET_ME',
		payload : { peerId, loginEnabled, email, name, socketId }
	});

export const setBrowser = (browser) =>
	({
		type    : 'SET_BROWSER',
		payload : { browser }
	});
export const setMeDislayName = (displayName) =>
	({
		type    : 'SET_DISPLAY_NAME',
		payload : { displayName }
	});
export const setLanguage = (lan) =>
	({
		type    : 'SET_LANGUAGE',
		payload : { lan }
	});

export const loggedIn = (flag) =>
	({
		type    : 'LOGGED_IN',
		payload : { flag }
	});

export const addRole = (roleId) =>
	({
		type    : 'ADD_ROLE',
		payload : { roleId }
	});

export const setRoles = (roles) =>
	({
		type    : 'SET_ROLES',
		payload : { roles }
	});

export const removeRole = (roleId) =>
	({
		type    : 'REMOVE_ROLE',
		payload : { roleId }
	});

export const setPicture = (picture) =>
	({
		type    : 'SET_PICTURE',
		payload : { picture }
	});

export const setMediaCapabilities = ({
	canSendMic,
	canSendWebcam,
	canShareScreen,
	canShareFiles
}) =>
	({
		type    : 'SET_MEDIA_CAPABILITIES',
		payload : { canSendMic, canSendWebcam, canShareScreen, canShareFiles }
	});

export const setAudioDevices = (devices) =>
	({
		type    : 'SET_AUDIO_DEVICES',
		payload : { devices }
	});

export const setAudioOutputDevices = (devices) =>
	({
		type    : 'SET_AUDIO_OUTPUT_DEVICES',
		payload : { devices }
	});

export const setWebcamDevices = (devices) =>
	({
		type    : 'SET_WEBCAM_DEVICES',
		payload : { devices }
	});

export const setRaisedHand = (flag) =>
	({
		type    : 'SET_RAISED_HAND',
		payload : { flag }
	});

export const setAudioInProgress = (flag) =>
	({
		type    : 'SET_AUDIO_IN_PROGRESS',
		payload : { flag }
	});

export const setAudioOutputInProgress = (flag) =>
	({
		type    : 'SET_AUDIO_OUTPUT_IN_PROGRESS',
		payload : { flag }
	});

export const setWebcamInProgress = (flag) =>
	({
		type    : 'SET_WEBCAM_IN_PROGRESS',
		payload : { flag }
	});

export const setScreenShareInProgress = (flag) =>
	({
		type    : 'SET_SCREEN_SHARE_IN_PROGRESS',
		payload : { flag }
	});

export const setRaisedHandInProgress = (flag) =>
	({
		type    : 'SET_RAISED_HAND_IN_PROGRESS',
		payload : { flag }
	});

export const setDisplayNameInProgress = (flag) =>
	({
		type    : 'SET_DISPLAY_NAME_IN_PROGRESS',
		payload : { flag }
	});

export const setIsSpeaking = (flag) =>
	({
		type    : 'SET_IS_SPEAKING',
		payload : { flag }
	});

export const setAutoMuted = (flag) =>
	({
		type    : 'SET_AUTO_MUTED',
		payload : { flag }
	});
export const setIsBreakoutRoom = (isBreakoutRoom) =>
	({
		type    : 'SET_IS_BREAKOUTROOM',
		payload : { isBreakoutRoom }
	});
export const setRoleType = (roleType) =>
	({
		type    : 'SET_ROLE_TYPE',
		payload : { roleType }
	});
export const setCloudRecordingInProgress = (flag) =>
	({
		type    : 'SET_IS_CLOUDRECORDING_IN_PROGRESS',
		payload : { flag }
	});
export const setStreamingInProgress = (isStreamingStart) =>
	({
		type    : 'SET_IS_STREAMING_IN_PROGRESS',
		payload : { isStreamingStart }
	});
export const setYoutubeStreamingInprogress = (youtubeStreamingInProgress) =>
	({
		type    : 'SET_IS_YOUTUBE_IN_PROGRESS',
		payload : { youtubeStreamingInProgress }
	});
export const setFaceBookStreamingInprogress = (faceBookStreamingInProgress) =>
	({
		type    : 'SET_IS_FACEBOOK_IN_PROGRESS',
		payload : { faceBookStreamingInProgress }
	});
export const setAccessAnnotations = (annotationAccess) => ({
	type    : 'SET_ANNOTATIONS',
	payload : { annotationAccess }
});
export const setPause = (pause) => ({
	type    : 'SET_PAUSE',
	payload : { pause }
});
export const clearRoles = () =>
	({
		type : 'CLEAR_ROLES'
	});

export const setScreenShareStatus = (screenShareStatus) =>
	({
		type    : 'SET_SCREEN_SHARE_STATUS',
		payload : { screenShareStatus }
	});

export const setScreenSharePeerId = (screenSharePeerId) =>
	({
		type    : 'SET_SCREEN_SHARE_PEER_ID',
		payload : { screenSharePeerId }
	});